import { Alert, Link } from "@mui/material";

const GuidelineNotice = () => (
  <Alert
    variant="outlined"
    severity="info"
    sx={{
      borderColor: "#003D4F",
      borderRadius: "4px",
      "& .MuiAlert-icon": { color: "#003D4F" },
    }}
  >
    If mailing address or contact information is not displayed below, update
    your contact information using the{" "}
    <Link
      target="_blank"
      href="https://docs.google.com/document/d/122CQzujAEucsgB5U50mKfKzrkNX7yk7SHXLF9qWHEHs"
      color="#BD4257"
      underline="hover"
    >
      guidelines
    </Link>{" "}
    in{" "}
    <Link
      target="_blank"
      href="https://wd3.myworkday.com/wday/authgwy/thoughtworks/login.htmld"
      color="#BD4257"
      underline="hover"
    >
      Workday
    </Link>
    . Refresh this page after the update.
  </Alert>
);

export default GuidelineNotice;
